import React from 'react';
import { closureLineColor } from '../../../constants/colors';
import AdmIntervalChartWrapper from '../adm_shared/AdmIntervalChartWrapper';

export default function AdmClosureIntervalChart(props) {
  const { closure, increment, d0_date, d2_date } = props;

  return (
    <AdmIntervalChartWrapper
      title='Defect Closure Prediction'
      closure={closure}
      increment={increment}
      d0_date={d0_date}
      d2_date={d2_date}
      closureColor={closureLineColor}
      showArrival={false}
      showClosure={true}
    />
  );
}
